module.exports = __webpack_public_path__ + "static/media/notes-medical.52c41a0e.svg";